import styled from 'styled-components';

const MessageContainer = styled.div`
  position: relative;
  z-index: 2;
`;

export default MessageContainer;
